<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16">
    <g fill="#fff">
      <path
        fill-rule="evenodd"
        d="M11.76 1.55c.24.05.24.28.24.28v.35c0 .24-.24.2-.24.2l-2.02-.36v.72c.56.48.9 1.1.9 1.79-.01.89-.58 1.67-1.45 2.16.64.22 1.11.58 1.23 1.07l.9 3.39c.03.17-.13.26-.32.26h-.95c-.15 0-.29-.03-.3-.18l-.8-2.83c-.37-1.2-3.6-1.33-4.32-.01L2.7 14.82c-.04.12-.17.18-.31.18H1.2c-.15 0-.24-.1-.19-.27l2.25-6.98c.24-.51.89-.88 1.7-1.11-.84-.5-1.38-1.26-1.38-2.13 0-.91.6-1.72 1.53-2.2V1.2L3.09.83C2.85.78 2.85.55 2.85.55V.2c0-.24.24-.2.24-.2l8.67 1.55ZM7.1 6.06c1.12 0 2.03-.68 2.04-1.54 0-.85-.9-1.54-2.03-1.54-1.12 0-2.03.68-2.03 1.54 0 .85.9 1.54 2.02 1.54Z"
        clip-rule="evenodd"
      />
      <path
        d="m14.28 8.3.1-.17c.1-.17.12-.16.37-.02.3.16.3.17.17.4l-.36.73c-1.36 2.7-3.38 6.73-5.13 6.76-1.21.02-3.14-2.41-3.41-3.19-.06-.16.07-.23.07-.23l1.13-.73s.14-.06.23.08l.2.32c.5.77 1.22 1.94 2.02 1.94 1.28 0 3.97-4.77 4.6-5.9Z"
      />
    </g>
  </svg>
</template>
